var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"card"},[_c('router-link',{staticClass:"image",attrs:{"to":{ name: "products/create/step1", params: { key: _vm.formsKey }}}},[_vm._t("default")],2),_c('div',{staticClass:"content"},[_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.name))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }